/**
 * --------------------------------------------------------------------------
 * Frontend template muenchen.de: config.js
 * --------------------------------------------------------------------------
 */

export default {
  envName: {
    dev: 'development',
    prod: 'production',
  },
  debugNamespace: 'mde',
  gridBreakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  }
};

